import { createFileRoute } from '@tanstack/react-router'
import { requireCompleteProfile } from '@/lib/auth-guard'
import BookQuizResultsPage from '@/pages/BookQuizResults'

export const Route = createFileRoute('/books/quiz-results/$slug')({
  ...requireCompleteProfile(),
  component: BookQuizResultsPage,
})